/*
 * @Author: liuc
 * @Date: 2022-03-28 14:38:39
 * @Description:
 */
/**
 * www.cloudscope.cn
 * Copyright (c) 2019. All Rights Reserved.
 * 统一管理后台接口
 */
// 登录注册相关接口
import LoginManagement from './LoginManagement.js';
// 通用接口
import Common from './Common.js';
// 租户注册管理
// 知识中心
import KnowledgeCenter from './KnowledgeCenter';
const api = {
    LoginManagement,
    Common,
    KnowledgeCenter
};

export default api;



// WEBPACK FOOTER //
// ./src/services/api.js